import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
import { plans } from "../data/content";
import { FadeUp } from "./FadeUp";
export function PlanPicker() {
  return <section id="pricing" className="scroll-mt-20 bg-band py-20 md:py-28" aria-labelledby="pricing-heading" data-id="element-283" data-mp="3aogyv1z2nb79">
      <div className="container-x" data-id="element-284" data-mp="3jn2g8tst4k6g">
        <FadeUp data-id="element-285" data-mp="3jodmr1dn0619">
          <h2 id="pricing-heading" className="font-serif text-[36px] leading-none tracking-[-0.02em] text-white sm:text-[clamp(40px,4.2vw,56px)]" data-id="element-286" data-mp="3jovnobb8v8fi">
            Start with <em className="italic text-signal" data-id="element-287" data-mp="3tkymp8asuqy8">what you need.</em>
          </h2>
        </FadeUp>

        <FadeUp className="mt-10 md:mt-12" data-id="element-288" data-mp="26auxug7qx5r">
          <ul className="grid gap-4 md:grid-cols-3 md:gap-5" data-id="element-289" data-mp="27m8glzgnja2">
            {plans.map(plan => <li key={plan.id} data-id="element-290" data-mp="67mlc26wvmf0">
                <a href="#book" aria-label={`${plan.name} — start your film`} className="group flex h-full flex-col border border-hairline bg-card transition-colors duration-200 hover:border-signal" data-id="element-291" data-mp="b7itmdmn600d">
                  <div className="relative aspect-[16/10] overflow-hidden" data-id="element-292" data-mp="9v4i7xv2aidl">
                    <img src={plan.image} alt={plan.alt} loading="lazy" className="h-full w-full object-cover opacity-80 transition-[transform,opacity] duration-300 ease-out group-hover:scale-[1.05] group-hover:opacity-100" data-id="element-293" data-mp="4xcocyauwm6r" />
                    <div className="absolute inset-0" style={{
                  background: "linear-gradient(0deg, rgba(25,25,25,1) 0%, rgba(25,25,25,0.4) 45%, rgba(25,25,25,0) 75%)"
                }} aria-hidden="true" data-id="element-294" data-mp="spjjju4uin4l" />
                    <span className="absolute left-5 top-5 bg-black/60 px-2 py-1 font-mono text-[10px] tracking-[0.14em] text-white/80" data-id="element-295" data-mp="ew1yu60fb4cz">
                      {plan.formats}
                    </span>
                    <h3 className="absolute bottom-4 left-6 font-serif text-[30px] leading-none tracking-[-0.01em] text-white md:text-[34px]" data-id="element-296" data-mp="17jocy87a1re3">
                      {plan.name}
                    </h3>
                  </div>

                  <div className="flex flex-1 flex-col px-6 pb-6 pt-4" data-id="element-297" data-mp="1vi5m3fsxw3av">
                    <p className="text-[13px] leading-relaxed text-body md:text-[14px]" data-id="element-298" data-mp="1honzfm4yiagm">{plan.line}</p>

                    <p className="mt-6 font-mono text-[10px] tracking-[0.14em] text-foot" data-id="element-299" data-mp="1loolnsyarpy8">FOR EXAMPLE</p>
                    <ul className="mt-2 border-t border-quiet" data-id="element-300" data-mp="17stdoi5frz9m">
                      {plan.examples.map(ex => <li key={ex} className="border-b border-quiet py-2.5 text-[13px] text-white/85 md:text-[14px]" data-id="element-301" data-mp="yq1yc79fwjcp">
                          {ex}
                        </li>)}
                    </ul>

                    <span className="mt-auto flex items-center justify-between pt-6 font-mono text-[11px] tracking-[0.12em] text-body transition-colors duration-150 group-hover:text-signal" data-id="element-302" data-mp="2t3telpm9y1h4">
                      START YOUR FILM
                      <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-303" data-mp="liumv4svlp89" />
                    </span>
                  </div>
                </a>
              </li>)}
          </ul>
        </FadeUp>

        <div className="mt-10 flex flex-col items-center gap-4 text-center" data-id="element-304" data-mp="qg38xgh5ades">
          <a href="#book" className="btn-graphite" data-id="element-305" data-mp="154zbiy0fmy80">
            <span className="roll inline-block" data-id="element-306" data-mp="107heo5zow9gd"><span data-id="element-307" data-mp="106615egfznc2">START YOUR FILM</span></span>
          </a>
          <p className="font-mono text-[11px] tracking-[0.1em] text-foot md:text-[12px]" data-id="element-308" data-mp="1e7077qg0pc7k">EVERY FILM IS SCOPED ON ONE CALL.</p>
        </div>
      </div>
    </section>;
}